import React from 'react';
import { Calendar } from 'lucide-react';
import CivicButton from './CivicButton';
import SectionHeader from './SectionHeader';
import { REGISTRATION_FORM_URL } from '../constants/links';

const CumbreNotice: React.FC = () => {
  return (
    <div className="cumbre__notice">
      <SectionHeader index="05" eyebrow="Convocatoria" title="¡La Cumbre ya comenzó!" />
      <h3 className="cumbre__subtitle">
        II Cumbre Nacional de Cristianos Políticos
      </h3>
      <p className="cumbre__description">
        Sé parte de la próxima generación de líderes cristianos que están transformando el Perú. Tu
        voz importa, tu participación marca la diferencia en el futuro de nuestro país desde una
        perspectiva de valores.
      </p>
      <aside
        className="cumbre__banner"
        role="region"
        aria-labelledby="cumbre-inscripcion-title"
        style={{
          background: '#FAFAF7',
          color: '#1A2332',
          borderLeft: '8px solid #E84721',
        }}
      >
        <p id="cumbre-inscripcion-title" className="cumbre__announcement" style={{ color: '#1A2332' }}>
          13 y 14 de noviembre de 2026 · Lima, Perú
        </p>
        <CivicButton
          href={REGISTRATION_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<Calendar size={16} />}
          size="large"
        >
          Registrarse Ahora
        </CivicButton>
      </aside>
    </div>
  );
};

export default CumbreNotice;
